export default __webpack_public_path__ + "images/LU.d220e52.png";